namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem2ExemptColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem2Exempt';
    }
}
